<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateCreateForm">
        <div class="container">
          <div class="row justify-content-between">
            <div class="repeater_wrapper mt-6 row">
              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    v-model.trim="data.partners_title_ar"
                  />
                  <label for="name_input" class="form-label"
                    >العنوان (عربي)</label
                  >
                </div>
              </div>
              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    v-model.trim="data.partners_title_en"
                  />
                  <label for="name_input" class="form-label"
                    >العنوان (إنجليزي)</label
                  >
                </div>
              </div>
              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <label for="textarea_1" class="form-label">
                    الوصف (عربي)</label
                  >
                  <textarea
                    class="form-control"
                    rows="5"
                    v-model="data.partners_description_ar"
                  ></textarea>
                </div>
              </div>
              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <label for="textarea_1" class="form-label"
                    >الوصف (إنجليزي)</label
                  >
                  <textarea
                    class="form-control"
                    rows="5"
                    v-model="data.partners_description_en"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="buttons_wrapper">
          <button class="base-btn" :class="btnIsLoading ? 'disabled' : ''">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "edit",

  data() {
    return {
      dateMenu: false,
      dateMenu2: false,
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.partners.title"),
          disabled: false,
          href: "/partners",
        },
        {
          text: this.$t("breadcrumb.partners.update"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== create_data
      data: {
        partners_title_ar: null,
        partners_title_en: null,
        partners_description_ar: null,
        partners_description_en: null,
      },
    };
  },

  methods: {
    // Validate Data
    validateCreateForm() {
      this.btnIsLoading = true;
      if (!this.data.partners_title_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: ` أدخل العنوان  (عربي)`,
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.partners_title_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: `أدخل العنوان  (انجليزي)`,
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.partners_description_ar) {
        this.$iziToast.error({
          timeout: 2000,
          message: `أدخل الوصف   (عربي)`,
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.partners_description_en) {
        this.$iziToast.error({
          timeout: 2000,
          message: `أدخل الوصف  (انجليزي)`,
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      submit_data.append("partners_title_ar", this.data.partners_title_ar);
      submit_data.append("partners_title_en", this.data.partners_title_en);
      submit_data.append(
        "partners_description_ar",
        this.data.partners_description_ar
      );
      submit_data.append(
        "partners_description_en",
        this.data.partners_description_en
      );
      // submit_data.append('_method', 'PUT')
      this.axios({
        method: "POST",
        url: "setting",
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/partners" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    // Set Rows
    setRows() {
      this.lodaing = true;
      this.axios({
        method: "GET",
        url: "partner",
      })
        .then((res) => {
          if (res.data.brief) {
            this.data = res.data.brief;
          }
          this.lodaing = false;
        })
        .catch(() => {
          this.lodaing = false;
        });
    },
  },

  // ======= hooks
  mounted() {
    // Set Rows
    this.setRows();
  },
};
</script>
